"use client";
import { QuickTradeView } from "@shared/src/components/modules/quick-trade/QuickTradeView";

export default function QuickTradePage() {
  return <QuickTradeView />;
}
